import { render, staticRenderFns } from "./project-btns.vue?vue&type=template&id=401fab3f&scoped=true"
import script from "./project-btns.vue?vue&type=script&lang=js"
export * from "./project-btns.vue?vue&type=script&lang=js"
import style0 from "./project-btns.vue?vue&type=style&index=0&id=401fab3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401fab3f",
  null
  
)

export default component.exports